<template>
    <button
        type="button"
        class="rounded-full tertiary-button-text focus:outline-none tertiary-button-hover-text button-tertiary-hover-bg"
        :disabled="disabled"
    >
        <loading-icon :visible="processing"></loading-icon>
        <slot></slot>
    </button>
</template>

<script>
import LoadingIcon from '@/components/ui/LoadingIcon.vue';

export default {
    components: {
        LoadingIcon,
    },
    props: {
        disabled: {
            default: false,
        },

        processing: {
            default: false,
        },
    },
};
</script>
